/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const SimpleSubmissionNavigateToLatestEditorSessionSettingParser = 
/* #__PURE__ */ parsers.object([
    [
        'name',
        /* #__PURE__ */ parsers.exactly('SIMPLE_SUBMISSION_NAVIGATE_TO_LATEST_EDITOR_SESSION'),
    ],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecBoolean)],
]);
export class SimpleSubmissionNavigateToLatestEditorSessionSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return SimpleSubmissionNavigateToLatestEditorSessionSettingParser.decode(input).map(res => new SimpleSubmissionNavigateToLatestEditorSessionSetting(res));
    }
    static unsafeDecode(input) {
        return SimpleSubmissionNavigateToLatestEditorSessionSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return SimpleSubmissionNavigateToLatestEditorSessionSettingParser.encode(data);
    }
    static schema() {
        return SimpleSubmissionNavigateToLatestEditorSessionSettingParser.schema();
    }
}
